import React, { FunctionComponent } from 'react';
import sliderTitleStyles from './sliderTitleStyles';
import { Box, Link as MuiLink } from '@material-ui/core';
import clsx from 'clsx';
import { useHistory } from 'react-router';
import { routeUtils } from '../../../../../../common/utils/routeUtils';
import GenericCarName from '../../../../../../common/components/presentation/genericCarName/GenericCarName';
import ComplexCarName from '../../../../../../common/components/presentation/complexCarName/ComplexCarName';
import MarketingLabel from '../../../../../../common/components/marketingLabel/MarketingLabel';
import useIsMobile from '../../../../../../common/react/useIsMobile';
import ComplexSubName from '../../../../../../common/components/presentation/complexCarName/ComplexSubName';
import Translation from '../../../../../../common/components/translation/Translation';

export interface ISliderTitle {
  modelName: string;
  variantName: string;
  centered: boolean;
  marketingLabel?: string;
  hasStock?: boolean;
  stockLink?: {
    url: string;
    label: string;
  };
  isComplexModel?: boolean;
  engine?: string;
  specPacks?: string;
}

const SliderTitle: FunctionComponent<ISliderTitle> = ({
  modelName,
  variantName,
  centered,
  marketingLabel,
  hasStock,
  stockLink,
  isComplexModel,
  engine,
  specPacks,
}) => {
  const styles = sliderTitleStyles();
  const history = useHistory();
  const isMobile = useIsMobile();

  return (
    <Box className={clsx([styles.container])}>
      <Box className={styles.nameContainer}>
        {isComplexModel ? (
          <ComplexCarName
            modelName={modelName}
            className={clsx([styles.title, { [styles.titleCentered]: centered }])}
            testId={'text:variantSlider:title'}
          />
        ) : (
          <GenericCarName
            modelName={modelName}
            variantName={variantName}
            className={clsx([styles.title, { [styles.titleCentered]: centered }])}
            testId={'text:variantSlider:title'}
          />
        )}

        {!isMobile && <MarketingLabel content={marketingLabel} inline={true} data-test={'text:marketing_label'} />}
      </Box>
      {isComplexModel && (
        <ComplexSubName
          specPacks={specPacks}
          engine={engine}
          className={clsx([styles.title, { [styles.titleCentered]: centered }])}
        />
      )}
      {hasStock && (
        <MuiLink
          data-test="customise:stock_link"
          className={styles.link}
          onClick={() => routeUtils.pushWithQueryParams(history, stockLink.url)}
        >
          <Translation id={stockLink.label} />
        </MuiLink>
      )}
    </Box>
  );
};

export default SliderTitle;
